export enum ReportParameters {
  StartDate = 0,
  EndDate = 1,
  ClientId = 2,
  UserId = 3,
  ScheduleId = 5,
  Agents = 6,
  StartBlock = 7,
  EndBlock = 8,
  WeekId = 9,
  ShowUnmetOnly = 10,
  ContractId = 11,
  PositionId = 12,
  ActiveType = 13,
  ContractIds = 14,
  PositionIds = 15,
  ClientIds = 16,
  DataSources = 17,
  SortByName = 18,
  ScheduleIds = 19,
  SnapshotDate = 20,
  PctIntervalId = 21,
  ClientScheduleId = 22,
  SortByNameTime = 23,
  DwQueueIds = 24,
  EventId = 25,
  ChatRoomId = 26,
  GigId = 27,
  Country = 28,
  ESignDocumentStatus = 29,
}

export enum ReportFilters {
  StartDate,
  EndDate,
  Schedule,
  Schedules,
  SnapshotDate,
  Agents,
  StartBlock,
  EndBlock,
  Weeks,
  Contract,
  Contracts,
  ShowUnmetOnly,
  Position,
  Positions,
  ActiveType,
  Clients,
  DataSources,
  SortByName,
  PctInterval,
  ClientSchedule,
  SortByNameTime,
  Workgroup,
  ChatRooms,
  GigId,
  Country,
  ESignDocumentStatus,
}

export enum ReportFilterType {
  Text,
  Date,
  DateTime,
  List,
  Int32,
}

export enum DatabaseAccessType {
  Private,
  Public,
}

export enum DatabaseStatus {
  Active,
  Pending,
  InProgress,
}

export enum AgentAccessLevel {
  NoAccess = 0,
  ViewAll = 1,
  ViewAllAndEditAll = 3,
  ViewOwn = 5,
  ViewAllAndEditOwn = 11,
  ViewOwnAndEditOwn = 15,
}

export enum ResourceDatabaseFieldTypeId {
  Text = 1,
  TextMultiline = 2,
  Number = 3,
  Checkbox = 4,
  Date = 5,
  Time = 6,
  DateTime = 7,
  Currency = 9,
  Email = 10,
  Phone = 12,
  WebLink = 13,
  FileAttachment = 14,
  List = 15,
  MemberList = 17,
  Calculated = 18,
}

export enum FilterParameters {
  ClientId = 0,
}

export enum SpeedTestStatus {
  Failed = 0,
  Passed = 1,
  GigReady = 2,
  GigReadyAdvanced = 3,
}
